import { plotSteps } from '@/mocks/plot';
import SectionHeading from './SectionHeading';

export default function PlotSection() {
  return (
    <section id="plot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="02 / 剧情介绍"
          title="一条完整的剧情脉络：从出走、受挫到重逢"
          desc="影片的故事并不复杂，却把「叛逆出走 — 遭遇背叛 — 独自远行 — 邂逅与成长」这条线讲得很完整。下面按起承转合的顺序，逐段梳理剧情走向（不含露骨描写）。"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-12">
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <div className="h-56 w-full md:h-72 lg:h-full lg:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20seaside%20sunset%20with%20lone%20traveler%20silhouette%20on%20a%20quiet%20coastal%20path%2C%20nostalgic%201990s%20film%20still%20mood%2C%20soft%20golden%20light%2C%20grainy%20texture%2C%20warm%20peach%20and%20amber%20palette&width=1200&height=900&seq=peach-plot-01&orientation=landscape"
                alt="黄昏海边小路上独自远行者剪影，呼应影片的旅行与成长主题"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-foreground-950/85 to-transparent p-4 md:p-5">
              <p className="font-heading text-sm font-semibold text-background-50 md:text-base">
                「一个人上路，也是一种长大」
              </p>
              <p className="mt-1 font-label text-xs text-background-100/80">剧情主线 · 旅途与成长</p>
            </div>
          </div>

          <ol className="relative flex flex-col gap-4">
            {plotSteps.map((step, index) => (
              <li
                key={step.title}
                className="relative flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex flex-col items-center">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-base font-semibold text-background-50">
                    {step.stage}
                  </span>
                  {index < plotSteps.length - 1 ? (
                    <span className="mt-2 hidden w-px flex-1 bg-background-300 md:block" />
                  ) : null}
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.content}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}